import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';

try {
    // Vendor
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('bootstrap');
    window.Cleave = require('cleave.js/dist/cleave');
    window.Dropzone = require('dropzone');
    window.moment = require('moment');
    window.Popper = require('@popperjs/core');
    window.Swal = require('sweetalert2');
    window.slick = require('slick-carousel');

    window.lightGallery = lightGallery;
    window.lgFullscreen = lgFullscreen;
    window.lgThumbnail = lgThumbnail;
    window.lgVideo = lgVideo;

    require('bootstrap');
    require('./main/vendor/turn.min.js');

    // Custom Override (Bootstrap 5)
    require('./main/modules/input-phone');
} catch (e) {
    //
}

// Core
require('./utilities');
require('./main/base');
